<template>
	<div class="container">
		<!-- 菜单导航 -->
		<Menu></Menu>
		<!-- 商业订单 -->
		<div class="ai">
			<div class="ai-conter">
				<iframe src="http://38.12.44.59:6080" width="100%" height="800px"></iframe>
			</div>
		</div>
		<!-- 底部链接 -->
		<Footer></Footer>
	</div>
</template>
<script>
	import Menu from '@/components/view/Menu'
	import Footer from '@/components/view/Footer'
	export default {
		name: 'ai',
		components: {
			Menu,
			Footer
		},
		created() {
			this.userInfo()
		},
		data() {
			return {
				userList: [],
			}
		},
		methods: {
			userInfo() {
				this.$axios({
				  method: 'post', // 请求格式
				  url: '/api/homework/list', // 请求路径
				  headers: { // 设置请求头
				    token: this.$cookieStore.getCookie('token')
				  },
				  data: { "classes_id": "25" }
				}).then(res => {
				
				}).catch(err => {
				  console.log(err)
				})
			},
		}
	}
</script>
<style scoped>
	.ai {
		width: 100%;
		height: 100%;
		padding: 50px 0;
		background-color: #f8f8f8;
	}

	.ai-conter {
		padding-bottom: 25px;
		margin: 0px;
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/Ai.vue